import { Injectable } from '@angular/core';
import { Apollo } from 'apollo-angular';
import { TaskServiceInterface } from './definitions/task-service-interface';
import { Observable } from 'rxjs';
import { ErrorsInterface } from '../errors/errors-interface';
import { DocumentNode } from 'graphql';
import { FetchResult } from '@apollo/client/core';

interface RejectFromRevisionResponse {
  task: {
    rejectFromRevision: {
      output: TaskServiceInterface;
      errors: ErrorsInterface;
    };
  };
}

@Injectable()
export class RejectFromRevisionService {
  constructor(private apollo: Apollo) {}

  rejectFromRevision(
    taskId: string,
    reason: string,
    mutation: DocumentNode
  ): Observable<FetchResult<RejectFromRevisionResponse>> {
    return this.apollo.mutate<RejectFromRevisionResponse>({
      mutation: mutation,
      variables: {
        taskId,
        reason,
      },
    });
  }
}
